import React from 'react';
import './Badge.css';

/** Plan decision 5: badges in words, one component. `outline` (default) is
 *  ink text in a 1.5px ink border (P `.badge`); `fill` is ink with paper text
 *  (P `.badge.fill`). The words are the disclosure — no emoji, no tint. */
export type BadgeVariant = 'outline' | 'fill';

export interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  'aria-label'?: string;
  className?: string;
}

export const Badge: React.FC<BadgeProps> = ({
  children,
  variant = 'outline',
  'aria-label': ariaLabel,
  className,
}) => {
  const classes = ['badge', `badge--${variant}`, className].filter(Boolean).join(' ');
  return (
    <span
      className={classes}
      // A generic span's aria-label is ignored by assistive tech, so a label
      // that says more than the visible words names the badge as an image.
      role={ariaLabel ? 'img' : undefined}
      aria-label={ariaLabel}
    >
      {children}
    </span>
  );
};

export default Badge;
